"use client";

import { HttpStatusCode } from "@/constants/http-status-code.enum";
import Error from "next/error";

export default function NotFoundPage() {
  return (
    <html lang="en">
      <body>
        <Error statusCode={HttpStatusCode.NotFound} />
      </body>
    </html>
  );
}
